export const SUPPORT_CONTACTS = {
  whatsapp: {
    phoneNumber: '15707768310',
    url: 'https://wa.me/15707768310',
  },
  telegram: {
    username: 'BeemiAppBot',
    url: 'https://t.me/BeemiAppBot',
  },
  email: {
    address: 'support@beemi.app',
    url: 'mailto:support@beemi.app?subject=Beemi Studio Support Request',
  },
  discord: {
    url: 'https://discord.gg/UP4JDtNZcm',
  },
} as const

export const SUPPORT_STORAGE_KEY = 'beemi_support_dont_show_again'
